import { render } from "./BrandIcon.vue?vue&type=template&id=99924144&scoped=true"
import script from "./BrandIcon.vue?vue&type=script&lang=js"
export * from "./BrandIcon.vue?vue&type=script&lang=js"

import "./BrandIcon.vue?vue&type=style&index=0&id=99924144&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99924144"]])

export default __exports__